import React, { useEffect, useRef, useState } from "react";
import { Table } from "antd";
import {
  Col,
  Row,
  InputGroup,
  InputGroupAddon,
  Card,
  CardBody,
} from "reactstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import IconCalendar from "../../../assets/images/icon/ic_calendar-black.svg";
import Loader from "../../../components/Loader";
import { baseUrl } from "../../../constants/environment";
import APIClient from "../../../helpers/APIClient";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index.js";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const optionTime: any = [
  {
    value: "day",
    label: "ngày",
  },
  {
    value: "week",
    label: "tuần",
  },
  {
    value: "month",
    label: "tháng",
  },
];

const InDepthReport = () => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState<any>({
    group_by: "day",
    from: moment().startOf("month").unix() * 1000,
    to: moment().endOf("month").unix() * 1000,
  });

  useEffect(() => {
    loadData();
  }, [filter]);

  const loadData = async () => {
    const url = `${baseUrl}/analytics/professional`;
    const params = {
      ...filter,
    };
    setLoading(true);
    const response: any = await APIClient.GET(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData: any = await response.response;

      if (filter?.group_by !== "month") {
        const totalMonth = totalsMonth(resData);

        // format lại data(bỏ doctor_id, update day)
        const newData = totalMonth?.map((doctor: any) => {
          const { doctor_id, ...rest } = doctor;
          return {
            ...rest,
            day: `Tổng tháng ${moment(filter?.from).format("MM")}`,
          };
        });

        resData.unshift({
          data: newData.reverse(),
        });
      }

      // tính tổng thông số theo ngày
      resData?.forEach((itemResponse: any) => {
        let totalDay: any = {
          doctor_name: "Tổng",
          total_booking: 0,
          total_examination: 0,
          total_prescription: 0,
          new_booking: 0,
          new_examination: 0,
          new_prescription: 0,
          new_has_fee_booking: 0,
          new_has_fee_examination: 0,
          new_has_fee_prescription: 0,
          new_free_booking: 0,
          new_free_examination: 0,
          new_free_prescription: 0,
          re_exam_booking: 0,
          re_exam_examination: 0,
          re_exam_prescription: 0,
          has_package_booking: 0,
          has_package_examination: 0,
          has_package_prescription: 0,
        };
        itemResponse?.data.forEach((item: any) => {
          for (let key in totalDay) {
            if (item[key] !== undefined) {
              totalDay[key] += Number(item[key]);
            }
          }
        });
        itemResponse?.data.push({
          ...totalDay,
          doctor_name: "Tổng",
          day:
            itemResponse?.day ||
            `Tổng tháng ${moment(filter?.from).format("MM")}`,
        });
      });

      // format lại data theo table
      let newArray: any = [];
      response.response?.forEach((item: any) => {
        item?.data?.forEach((itemData: any) => {
          newArray.push(itemData);
        });
      });
      setData(newArray);
    }
  };

  // Hàm tính tổng thông số cho từng bác sĩ
  const totalsMonth = (data: any) => {
    const summedTotals: any = {};
    data.forEach((day: any) => {
      day.data.forEach((doctor: any) => {
        // Cộng các số trong thông số của từng bác sĩ
        if (!summedTotals[doctor.doctor_id]) {
          summedTotals[doctor.doctor_id] = { ...doctor };
        } else {
          for (const key in doctor) {
            if (!isNaN(Number(doctor[key])) && doctor[key] !== undefined) {
              summedTotals[doctor.doctor_id][key] =
                (Number(summedTotals[doctor.doctor_id][key]) || 0) +
                Number(doctor[key]);
            }
          }
        }
      });
    });

    return Object.values(summedTotals);
  };

  const DataFilter = (props: any) => {
    const { filter, setFilter } = props;

    const handleChange = (e: any) => {
      const { name, value } = e?.target;
      setFilter({
        ...filter,
        [name]: value,
      });
    };

    const handleChangeFilterDate = (date: any) => {
      const from = moment(date[0]).startOf("month").unix() * 1000;
      const to = moment(date[0]).endOf("month").unix() * 1000;
      setFilter({
        ...filter,
        from: from,
        to: to,
      });
    };

    const createMonthSelectPlugin = (options?: any) =>
      new monthSelectPlugin(options);

    return (
      <Row className="mb-3 filter-custom ml-4 mr-4">
        <Col xl={2}>
          <Select
            className="react-select mb-2"
            classNamePrefix="react-select"
            placeholder="-Xem theo ngày-"
            options={optionTime}
            onChange={(value: any) => {
              handleChange({
                target: { name: "group_by", value: value.value },
              });
            }}
            value={optionTime?.filter(
              (option: any) => filter?.group_by == option.value
            )}
          ></Select>
        </Col>
        <Col xl={2}>
          <InputGroup className="form-control picker-custom">
            <Flatpickr
              value={[
                new Date(
                  moment(Number(filter?.from)).startOf("month").unix() * 1000
                ),
              ]}
              onChange={(date: any) => handleChangeFilterDate(date)}
              options={{
                plugins: [
                  createMonthSelectPlugin({
                    dateFormat: "m/Y", //defaults to "F Y"
                    altFormat: "F Y", //defaults to "F Y"
                  }),
                ],
                locale: Vietnamese,
              }}
              placeholder="-Thời gian tạo-"
            />
            <InputGroupAddon
              addonType="append"
              className="d-flex align-items-center"
            >
              <img src={IconCalendar} alt="icon" />
            </InputGroupAddon>
          </InputGroup>
        </Col>
      </Row>
    );
  };

  const DataList = (props: any) => {
    const { data } = props;

    // tính tỉ lệ
    const calculate_ratio = (a: any, b: any) => {
      if (a == 0 || a == undefined || b == 0 || b == undefined) {
        return "0";
      } else {
        return (((a || 0) / (b || 1)) * 100).toFixed(2);
      }
    };

    const columns: any = [
      {
        title: "Thời gian",
        dataIndex: "day",
        key: "day",
        width: 120,
        fixed: "left",
        render: (text: any, record: any, index: any) => {
          const currentDate = data?.[index]?.day;
          const previousDate = index > 0 ? data?.[index - 1]?.day : null;
          const rowSpan =
            currentDate !== previousDate
              ? data?.filter((item: any) => item.day === currentDate).length
              : 0;
          return {
            children: text,
            props: {
              rowSpan: rowSpan,
            },
          };
        },
      },
      {
        title: "Bác sĩ khám",
        dataIndex: "doctor_name",
        key: "doctor_name",
        width: 150,
        fixed: "left",
        render: (_: any, item: any) => _,
      },
      {
        title: "BC TỔNG",
        className: "BC_TONG",
        backGround: "rgba(238, 238, 247, 0.75)",
        children: [
          {
            title: "Tổng số lịch tư vấn",
            dataIndex: "total_booking",
            key: "total_booking",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.total_booking || 0,
          },
          {
            title: "Tổng số ca tư vấn được",
            dataIndex: "total_examination",
            key: "total_examination",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.total_examination || 0,
          },
          {
            title: "Tỉ lệ",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) =>
              calculate_ratio(item?.total_examination, item?.total_booking),
          },
          {
            title: "Tổng số ca tư vấn được",
            dataIndex: "total_prescription",
            key: "total_prescription",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.total_prescription || 0,
          },
          {
            title: "Tỉ lệ",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) =>
              calculate_ratio(item?.total_prescriptio, item?.total_examination),
          },
        ],
      },
      {
        title: "Khám mới",
        className: "kham_moi",
        dataIndex: "new_examinations",
        key: "new_examinations",
        children: [
          {
            title: "Tổng khám mới",
            className: "tong_kham_moi",
            dataIndex: "companyAddress",
            key: "companyAddress",
            children: [
              {
                title: "Tổng số lịch tư vấn",
                dataIndex: "new_booking",
                key: "new_booking",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_booking || 0,
              },
              {
                title: "Tổng số ca tư vấn được",
                dataIndex: "new_examination",
                key: "new_examination",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_examination || 0,
              },
              {
                title: "Tỉ lệ",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  calculate_ratio(item?.new_examination, item?.new_booking),
              },
              {
                title: "Tổng số ca kê đơn",
                dataIndex: "new_prescription",
                key: "new_prescription",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_prescription || 0,
              },
              {
                title: "Tỉ lệ",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  calculate_ratio(
                    item?.new_prescription,
                    item?.new_examination
                  ),
              },
            ],
          },
          {
            title: "Khám lẻ có phí",
            className: "kham_le_co_phi",
            dataIndex: "companyName",
            key: "companyName",
            children: [
              {
                title: "Số lịch tư vấn",
                dataIndex: "new_has_fee_booking",
                key: "new_has_fee_booking",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_has_fee_booking || 0,
              },
              {
                title: "Số ca tư vấn được",
                dataIndex: "new_has_fee_examination",
                key: "new_has_fee_examination",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  item?.new_has_fee_examination || 0,
              },
              {
                title: "Tỉ lệ",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  calculate_ratio(
                    item?.new_has_fee_examination,
                    item?.new_has_fee_booking
                  ),
              },
              {
                title: "Số ca kê đơn",
                dataIndex: "new_has_fee_prescription",
                key: "new_has_fee_prescription",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  item?.new_has_fee_prescription || 0,
              },
              {
                title: "Tỉ lệ",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  calculate_ratio(
                    item?.new_has_fee_prescription,
                    item?.new_has_fee_examination
                  ),
              },
            ],
          },
          {
            title: "Khám free (tăng cao)",
            className: "kham_free",
            dataIndex: "companyName",
            key: "companyName",
            children: [
              {
                title: "Số lịch tư vấn",
                dataIndex: "new_free_booking",
                key: "new_free_booking",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_free_booking || 0,
              },
              {
                title: "Số ca tư vấn được",
                dataIndex: "new_free_examination",
                key: "new_free_examination",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_free_examination || 0,
              },
              {
                title: "Tỉ lệ",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  calculate_ratio(
                    item?.new_free_examination,
                    item?.new_free_booking
                  ),
              },
              {
                title: "Số ca kê đơn",
                dataIndex: "new_free_prescription",
                key: "new_free_prescription",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) => item?.new_free_prescription || 0,
              },
              {
                title: "Tỉ lệ",
                width: 100,
                className: "color_green",
                render: (_: any, item: any) =>
                  calculate_ratio(
                    item?.new_free_prescription,
                    item?.new_free_examination
                  ),
              },
            ],
          },
        ],
      },
      {
        title: "Tái khám",
        dataIndex: "gender",
        key: "gender",
        className: "tai_kham",
        children: [
          {
            title: "Số lịch tư vấn",
            dataIndex: "re_exam_booking",
            key: "re_exam_booking",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.re_exam_booking || 0,
          },
          {
            title: "Số ca tư vấn được",
            dataIndex: "re_exam_examination",
            key: "re_exam_examination",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.re_exam_examination || 0,
          },
          {
            title: "Tỉ lệ",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) =>
              calculate_ratio(item?.re_exam_examination, item?.re_exam_booking),
          },
          {
            title: "Số ca kê đơn",
            dataIndex: "re_exam_prescription",
            key: "re_exam_prescription",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.re_exam_prescription || 0,
          },
          {
            title: "Tỉ lệ",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) =>
              calculate_ratio(
                item?.re_exam_prescription,
                item?.re_exam_examination
              ),
          },
        ],
      },
      {
        title: "Khám gói đồng hành",
        dataIndex: "gender",
        key: "gender",
        className: "kham_goi_dong_hanh",
        children: [
          {
            title: "Số lịch tư vấn",
            dataIndex: "has_package_booking",
            key: "has_package_booking",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.has_package_booking || 0,
          },
          {
            title: "Số ca tư vấn được",
            dataIndex: "has_package_examination",
            key: "has_package_examination",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.has_package_examination || 0,
          },
          {
            title: "Tỉ lệ",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) =>
              calculate_ratio(
                item?.has_package_examination,
                item?.has_package_booking
              ),
          },
          {
            title: "Số ca kê đơn",
            dataIndex: "has_package_prescription",
            key: "has_package_prescription",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) => item?.has_package_prescription || 0,
          },
          {
            title: "Tỉ lệ",
            width: 100,
            className: "color_green",
            render: (_: any, item: any) =>
              calculate_ratio(
                item?.has_package_prescription,
                item?.has_package_examination
              ),
          },
        ],
      },
      {
        title: "Các vấn đề chính",
        width: 250,
        className: "main_problems",
      },
    ];

    // check màu line total day
    const getRowClassName = (record: any, index: number) => {
      if (record.doctor_name === "Tổng") {
        return "total-row";
      }
      if (
        record.day === `Tổng tháng ${moment(filter?.from).format("MM")}` ||
        record.day === undefined
      ) {
        return "total-month-row";
      }
      return "";
    };

    return (
      <Table
        columns={columns}
        dataSource={data}
        bordered
        size="middle"
        scroll={{ x: 1500, y: 700 }}
        pagination={false}
        rowClassName={getRowClassName}
      />
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardBody className="pt-4 pb-4 pl-0 pr-0">
              <DataFilter
                filter={filter}
                setFilter={(filter: any) => setFilter(filter)}
              />
              <DataList data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {loading && <Loader />}
    </React.Fragment>
  );
};

const mapState = (state: any) => {
  return {
    user: state.Auth.user,
  };
};

export default connect(mapState)(InDepthReport);
